module.exports = __webpack_public_path__ + "static/smileImage-7cfef26b8ec430c02187449fa8edeaf8.jpg";